import * as React from 'react';
import { SVGProps } from 'react';

const FileIconMp3SizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width={24} height={28} rx={2} />
    <path
      opacity={0.7}
      fillRule="evenodd"
      clipRule="evenodd"
      d="m17 12-8 2v8H7.5a1.5 1.5 0 0 0 0 3H8a2 2 0 0 0 2-2v-5.25l6-1.5V20h-1.5a1.5 1.5 0 0 0 0 3h.5a2 2 0 0 0 2-2v-9Zm-1 2.25-6 1.5v1l6-1.5v-1Z"
      fill="#fff"
    />
    <path
      d="M19 7.42c0 .553-.134.957-.403 1.21-.268.247-.704.37-1.308.37H16V8h1.26c.255 0 .44-.057.56-.17.12-.12.18-.307.18-.56v-.55c0-.22-.066-.393-.2-.52a.715.715 0 0 0-.53-.2h-.958V5h.977a.733.733 0 0 0 .523-.2.696.696 0 0 0 .211-.53v-.55c0-.253-.06-.437-.18-.55-.115-.113-.3-.17-.554-.17H16V2h1.168c.57 0 1 .127 1.288.38.296.247.443.64.443 1.18v.63c0 .513-.184 1.05-.553 1.31.436.24.654.65.654 1.23v.69Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.8 4v.24c.207-.16.473-.24.8-.24h.7c.587 0 1.017.127 1.29.38.273.247.41.653.41 1.22v1.8c0 .56-.14.967-.42 1.22-.273.253-.7.38-1.28.38h-1.29v2H11V4h.8Zm.85 1c-.22 0-.383.06-.49.18a.53.53 0 0 0-.16.37L12.01 8h1.24c.247 0 .433-.057.56-.17.127-.113.19-.273.19-.48v-1.7c0-.207-.063-.367-.19-.48-.127-.113-.313-.17-.56-.17h-.6Z"
      fill="#fff"
    />
    <path
      d="M6.5 4c.384 0 .735.144 1 .382a1.5 1.5 0 0 1 2.497 1.026L10 5.41V9H9V5.5a.5.5 0 0 0-1 0V9H7V5.5a.5.5 0 0 0-1 0V9H5V4h.8v.173c.209-.11.447-.173.7-.173Z"
      fill="#fff"
    />
  </svg>
);
export default FileIconMp3SizeS;
